import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { LoginRoute, ProtectedRoute } from "./pages/protected-route";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import HomePage from "./pages/HomePage";
import ViewBusesPage from "./pages/ViewBusesPage";
import PaymentPage from "./pages/PaymentPage";
import PendingTicketPage from "./pages/PendingTicketPage";
import SearchTicketPage from "./pages/SearchTicketPage";
import DownloadTicketPage from "./pages/DownloadTicketPage";
import PaymentInstructionsPage from "./pages/PaymentInstructionsPage";
import Test from "./test";
import VerifyOtpForm from "./pages/VerifyOtpPage";

function App() {
  const token = localStorage.getItem("liyu_login_token");

  return (
    <Router basename="/portal">
      <Switch>
        <Box>
          <CssBaseline />
          {/* {routes.map((route, i) => ( */}
          <LoginRoute path="/login" component={LoginPage} />
          <LoginRoute path="/signup" component={SignupPage} />
          <Route path="/verify-otp" component={VerifyOtpForm} />
          <ProtectedRoute exact path="/" component={HomePage} />
          <ProtectedRoute exact path="/view-buses" component={ViewBusesPage} />
          <ProtectedRoute
            exact
            path="/payment/:bookingId"
            component={PaymentPage}
          />
          <ProtectedRoute
            exact
            path="/payment-instructions/:bookingId"
            component={PaymentInstructionsPage}
          />
          <ProtectedRoute
            exact
            path="/pending-ticket"
            component={PendingTicketPage}
          />
          {/* <ProtectedRoute exact path="/search-ticket" component={SearchTicketPage} /> */}
          {/* <ProtectedRoute exact path="/download-ticket" component={DownloadTicketPage} /> */}

          <Route path="/test" component={Test} />
          {/* ))} */}
          <Typography
            variant="body2"
            color="textSecondary"
            align="center"
            my={6}
          >
            Copyright ©
            <a
              href="https://liyubus.com/"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              Liyubus
            </a>{" "}
            {new Date().getFullYear()}.
          </Typography>
        </Box>
      </Switch>
    </Router>
  );
}

export default App;
